import { BorderTop } from "@mui/icons-material";
import React from "react";
import StyledTooltip from "../../common/StyledTooltip";

export default function FinancialStatementTable({ data }) {
  console.log("FinancialStatementTable data:", data);
  const rows = [
    // {
    //   name: "Principal",

    //   amount: data?.financialBreakdown?.principal?.display || "₹0",
    //   originalValue: data?.financialBreakdown?.principal?.amount || 0,

    //   percent: data?.financialBreakdown?.principal?.percentage + "%" || "0%",

    //   tag: "Core",

    //   color: "#1447E6",

    //   bg: "#DBEAFE",

    //   textColor: "#155DFC",
    // },

    {
      name: "Interest Income",

      amount: data?.financialBreakdown?.interest?.display || "₹0",
      originalValue: data?.financialBreakdown?.interest?.amount || 0,

      percent: data?.financialBreakdown?.interest?.percentage + "%" || "0%",

      tag: "Lending",

      color: "#008236",

      bg: "#DCFCE7",

      textColor: "#00A63E",
    },

    {
      name: "Processing Fee",

      amount: data?.financialBreakdown?.processingFee?.display || "₹0",
      originalValue: data?.financialBreakdown?.processingFee?.amount || 0,

      percent:
        data?.financialBreakdown?.processingFee?.percentage + "%" || "0%",

      tag: "Upfront",

      color: "#A65F00",

      bg: "#FFE2E2",

      textColor: "#D08700",
    },
    {
      name: "Processing Fee Without GST",

      amount: data?.financialBreakdown?.processingFeeWithoutGst?.display || "₹0",
      originalValue: data?.financialBreakdown?.processingFeeWithoutGst?.amount || 0,

      percent:
        data?.financialBreakdown?.processingFeeWithoutGst?.percentage + "%" || "0%",

      tag: "Upfront",

      color: "#A65F00",

      bg: "#FFE2E2",

      textColor: "#D08700",
    },

    {
      name: "Charges",

      amount: data?.financialBreakdown?.charges?.display || "₹0",
      originalValue: data?.financialBreakdown?.charges?.amount || 0,

      percent: data?.financialBreakdown?.charges?.percentage + "%" || "0%",

      tag: "Other",

      color: "#C10007",

      bg: "#FEF9C2",

      textColor: "#E7000B",
    },
  ];

  const totalAmount =
    // (data?.financialBreakdown?.principal?.amount || 0) +
    (data?.financialBreakdown?.interest?.amount || 0) +
    (data?.financialBreakdown?.processingFee?.amount || 0) +
    // (data?.financialBreakdown?.processingFeeWithoutGst?.amount || 0) +
    (data?.financialBreakdown?.charges?.amount || 0);
  const totalPercentAmount =
    // (data?.financialBreakdown?.principal?.amount || 0) +
    (data?.financialBreakdown?.interest?.percentage || 0) +
    (data?.financialBreakdown?.processingFee?.percentage || 0) +
    // (data?.financialBreakdown?.processingFeeWithoutGst?.amount || 0) +
    (data?.financialBreakdown?.charges?.percentage || 0);

  const totalDisplay = `₹${(totalAmount / 100000).toFixed(2)}L`;
  return (
    <div
      style={{
        background: "#ffffff",
        border: "0.8px solid #E5E7EB",
        borderRadius: "12px",
        padding: "22px",
        marginTop: window.innerWidth > 1800 ? "30px" :"20px",
        boxShadow: "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          fontWeight: "600",
          marginBottom: "18px",
          color: "#0A0A0A",
        }}
      >
        Financial MIS Statement
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr
            style={{
              color: "#0A0A0A",
              borderBottom: "2px solid #D1D5DC",
              fontWeight: "500",
            }}
          >
            <th style={thStyleLeft}>Income Component</th>

            <th style={thStyleCenter}>Amount</th>

            <th style={thStyleCenter}>% of Total</th>

            <th style={thStyleRight}>Category</th>
          </tr>
        </thead>

        <tbody>
          {rows && rows?.length > 0 && rows?.map((row, i) => (
            <tr
              key={i}
              style={{
                borderBottom: "0.8px solid #F3F4F6",
              }}
            >
              <td style={tdLeft}>{row?.name}</td>

              <td
                style={{
                  ...tdCenter,
                  color: row?.textColor,
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                <StyledTooltip value={row?.originalValue}>
                  {row?.amount}
                </StyledTooltip>
              </td>

              <td style={tdCenter}>{row?.percent}</td>

              <td style={tdRight}>
                <span
                  style={{
                    background: row?.bg,
                    color: row?.color,
                    padding: "4px 10px",
                    borderRadius: "8px",
                    fontSize: window.innerWidth > 1800 ? "14px" :"12px",
                    fontWeight: "600",
                  }}
                >
                  {row.tag}
                </span>
              </td>
            </tr>
          ))}

          <tr
            style={{
              background: "#f7f8fb",
              fontWeight: "600",
              borderTop: "2px solid #D1D5DC",
              padding: "10px 20px",
            }}
          >
            <td style={tdTotal}>Total Income</td>

            <td
              style={{
                ...tdCenter,
                color: "#9810FA",
                fontWeight: "700",
                fontSize: "18px",
              }}
            >
              <StyledTooltip value={totalAmount}>
                {totalDisplay}
              </StyledTooltip>
            </td>

            <td style={tdCenter}>{totalPercentAmount ?? 0}%</td>

            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

const thStyleLeft = {
  textAlign: "left",
  paddingLeft: "20px",
  fontWeight: "700",
  color: "#0A0A0A",
  fontSize: window.innerWidth > 1800 ? "18px" :"16px",
};

const thStyleCenter = {
  textAlign: "center",
  padding: "20px 0",
  fontSize: window.innerWidth > 1800 ? "18px" :"16px",
  color: "#0A0A0A",
  fontWeight: "700",
};

const thStyleRight = {
  textAlign: "right",
  padding: "10px 0",
  fontSize: window.innerWidth > 1800 ? "18px" :"16px",
  color: "#0A0A0A",
  fontWeight: "700",
};

const tdLeft = {
  padding: "14px 20px",
  color: "#0A0A0A",
  fontWeight: "500",
  fontSize: window.innerWidth > 1800 ? "18px" :"16px",
};
const tdTotal = {
  padding: "14px 20px",
  color: "#111827",
  fontWeight: "700",
  fontSize: window.innerWidth > 1800 ? "18px" :"18px",
  BorderTop: "1px solid #111827",
};

const tdCenter = {
  textAlign: "center",
  padding: "14px 0",
  color: "#0A0A0A",
  fontWeight: "400",
  fontSize: window.innerWidth > 1800 ? "18px" :"16px",
};

const tdRight = {
  textAlign: "right",
  padding: "14px 0",
  fontSize: window.innerWidth > 1800 ? "16px" :"14px",
  fontWeight: "400",
};
